import React from 'react';
import LicenseTab from './OnboardLicense';
import DeltaMBNTab from './OnboardMBN';


function Onboard ({ tab }) {

    switch (tab) {
        case "License":
            return <LicenseTab />;
        case "Delta MBN":
            return <DeltaMBNTab />;
        default:
            return <div className='tab-content'>Select a valid Onboard Tab</div>;
    }
}

export default Onboard;